import styled from 'styled-components'

export const Container = styled.aside`
  display: flex;
  flex-direction: column;
  width: 362px;
  flex-shrink: 0;
  background-color: ${props => props.theme.colors.background.primary};
  border-left: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
  flex-shrink: 0;
  min-height: ${props => props.theme.size.XL};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp24};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  padding: ${props => props.theme.spacing.sp24};
  overflow-y: auto;
`
